.softwares-page {
  display: flex;
  width: 100%;
  height: calc(100vh - var(--navbar-height));
  overflow: hidden;
}

.softwares-sidebar {
  display: flex;
  flex: 0 0 280px;
  flex-direction: column;
  padding: 1.25rem 1rem;
  overflow-y: auto;
  border-right: 1px solid #e5e7eb;
}

.softwares-content {
  flex: 1;
  min-width: 0;
  padding: 1.5rem 2rem 2rem;
  overflow: auto;
}

.header-row {
  margin-bottom: 1rem;
}

.softwares-overview {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.softwares-overview ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.softwares-overview li {
  margin-bottom: 0.4rem;
}

.software-button {
  width: 100%;
  padding: 0.45rem 0.65rem;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 6px;
  text-align: left;
  cursor: pointer;
  font-size: 0.85rem;
  color: var(--umati-text);
}

.software-button:hover {
  background-color: #f1f5f9;
}

.software-button[aria-current='true'] {
  border-color: var(--umati-blue);
  background-color: #e6f6fd;
  color: var(--umati-blue);
}

.name-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.25rem;
}

.name-subheading {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 1.25rem;
  font-size: 0.85rem;
  color: var(--umati-muted);
}

.images-row {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: flex-start;
}

.image-card {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  align-items: flex-start;
}

.image-label {
  font-size: 0.75rem;
  text-transform: capitalize;
  color: var(--umati-muted);
}

.sw-image,
.image-placeholder {
  width: 160px;
  height: 110px;
  object-fit: contain;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #fafafa;
}

.image-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  color: #9ca3af;
  border-style: dashed;
}

.table thead th {
  font-weight: 600;
  font-size: 0.85rem;
  color: var(--umati-text);
}

.table tbody td,
.table tbody th {
  font-size: 0.85rem;
  vertical-align: middle;
}

.description p:last-child {
  margin-bottom: 0;
}
